import { formatDate } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { format } from 'date-fns';
import { tap } from 'rxjs';
import { BasicAction } from 'src/app/core-module/models/Audits/AuditResults/basic-action';
import { BasicAuditReturn } from 'src/app/core-module/models/Audits/AuditResults/basic-audit-return';
import { DDL } from 'src/app/core-module/models/ddl';
import { AuditLocation } from 'src/app/core-module/models/Locations/audit-location';
import { ReportData } from 'src/app/core-module/models/Reports/report-data';
import { ReportDetail } from 'src/app/core-module/models/Reports/report-detail';
import { ReportFilters } from 'src/app/core-module/models/Reports/report-filters';
import { ReportFiltersResult } from 'src/app/core-module/models/Reports/report-filters-result';
import { ReportRequest } from 'src/app/core-module/models/Reports/report-request';
import { ReportResult } from 'src/app/core-module/models/Reports/report-results';
import { BBCRiskAnalysisRow } from 'src/app/core-module/models/Reports/ReportingRows/bbc-risk-analysis-row';
import { MissedAuditRow } from 'src/app/core-module/models/Reports/ReportingRows/missed-audit-row';
import { MissedAuditRowDetail } from 'src/app/core-module/models/Reports/ReportingRows/missed-audit-row-detail';
import { MonthlyActionsRow } from 'src/app/core-module/models/Reports/ReportingRows/monthly-actions-row';
import { MonthlyAuditCompletionRow } from 'src/app/core-module/models/Reports/ReportingRows/monthly-audit-completion-row';
import { NonComplianceRow } from 'src/app/core-module/models/Reports/ReportingRows/non-compliance-row';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { ExportService } from 'src/app/core-module/services/export.service';
import { ReportingService } from 'src/app/core-module/services/reporting.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { CHART_SERIES_COLOURS } from 'src/app/core-module/constants/chart-palette';
import { DashboardPortfolioFilterOption } from 'src/app/core-module/models/Dashboards/dashboard.models';
import { environment } from 'src/environments/environment';
import { CustomerContextService } from 'src/app/core-module/services/customer-context.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrl: './reports.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsComponent {
  private readonly customerContext = inject(CustomerContextService);

  private readonly auditCompletionReportId = 2;
  private readonly auditCompletionOverviewReportId = 4;
  private readonly actionsOverviewReportId = 5;
  private readonly shiftedAuditCompletionReportId = 6;
  public SelectedAudit: BasicAuditReturn = new BasicAuditReturn();
  public SelectedFrequency: DDL = new DDL();
  public SelectedAuditType: DDL = new DDL();
  public SelectedReport: ReportDetail = new ReportDetail();
  public SelectedLocation: AuditLocation = new AuditLocation();
  public IncludeSubLocations: boolean = false;

  public showAuditFilter: boolean = true;
  public showLocationFilter: boolean = true;

  public collapseAuditFilter: boolean = false;
  public collapseLocationFilter: boolean = false;
  public collapseOptionsFilter: boolean = false;

  public showFilters: boolean = true;
  public StartDate: Date = new Date();
  public EndDate: Date = new Date();
  public Frequencies: DDL[] = [];
  private _Frequencies: DDL[] = [];
  public Reports: ReportDetail[] = [];
  public AuditTypes: DDL[] = [];
  public Audits: BasicAuditReturn[] = [];
  public DisplayAudits: BasicAuditReturn[] = [];
  public Locations: AuditLocation[] = [];
  public LocationGroups: { label: string; items: AuditLocation[] }[] = [];
  public LocationGroupsWithAll: { label: string; items: AuditLocation[] }[] = [];
  public useLocationGroups: boolean = false;
  public LocationLevels: DDL[] = [];
  public QualityManagers: DashboardPortfolioFilterOption[] = [];
  public BusinessDevelopmentManagers: DashboardPortfolioFilterOption[] = [];
  public SelectedQualityManagerID: number | null = null;
  public SelectedBusinessDevelopmentManagerID: number | null = null;
  public showQualityManagerFilter: boolean = false;
  public showBusinessDevelopmentManagerFilter: boolean = false;
  private reportingLocations: AuditLocation[] = [];
  private reportingLocationsByID = new Map<number, AuditLocation>();

  public FetchingReport: boolean = false;
  public NoData: boolean = false;
  public FetchingExport: boolean = false;
  //report storage
  //**Non-compliance** */
  private _NonComplianceRows: NonComplianceRow[] = [];
  public DisplayNonComplianceRows: NonComplianceRow[] = [];
  private CurrentNonComplianceOrder: number = -1;
  public selectedNonComplianceRow: NonComplianceRow = new NonComplianceRow();
  public showNonComplianceDetails: boolean = false;
  public showAllNonComplianceDetails: boolean = false;
  public showAllAuditCompletionDetails: boolean = false;
  public showFullDetailsSection: boolean = false;
  //**Audit Completion** */
  private _AuditCompletionRows: MissedAuditRow[] = [];
  public DisplayAuditCompletionRows: MissedAuditRow[] = [];
  private CurrentAuditCompletionOrder: number = -1;
  public selectedAuditCompletionRow: MissedAuditRow = new MissedAuditRow();
  public _RiskAnalysisRows: BBCRiskAnalysisRow[] = [];

  public showAuditCompletionDetails: boolean = false;
  public showOnlyAuditCompletionIssueRows: boolean = false;
  public reportLoaded: boolean = false;
  public monthlyAuditCompletionChartData: any = null;
  public monthlyAuditCompletionChartOptions: any = null;
  public monthlyAuditCompletionRows: { month: string; total: number }[] = [];
  public monthlyActionsChartData: any = null;
  public monthlyActionsChartOptions: any = null;
  public monthlyActionsRows: { month: string; raised: number; completed: number; completedOnTime: number }[] = [];

  constructor(private reportingService: ReportingService, private util: UtilService, private toast: ToastrService, private ex: ExportService) {
    this.getFilters();
  }
  getFilters() {
    this.reportingService.getReportFilters().pipe(
      tap((res:ReportFiltersResult) => {
        if (res.IsError) {

        } else {
          this.setFilters(res.Filters);
        }
      })
    ).subscribe();
  }
  switchAllDetails() {
    this.setAllDetailSections(!this.showFullDetailsSection);
    this.showFilters = false;
  }
  setFilters(filters: ReportFilters) {
    this.AuditTypes = [];
    this.AuditTypes.push(new DDL({ ID: -1, Description: this.customerContext.displayText("All Audit Types") }));
    this.SelectedAuditType = this.AuditTypes[0];
    if (filters.AuditTypes.length > 0) {
      filters.AuditTypes.forEach(e => {
        this.AuditTypes.push(new DDL(e));
      });
    }
    this._Frequencies = [];
    this._Frequencies.push(new DDL({ ID: -1, Description: this.customerContext.displayText("All Audit Frequencies") }));
    if (filters.Frequencies.length > 0) {
      filters.Frequencies.forEach(e => {
        this._Frequencies.push(new DDL(e));
      });
    }
    this.setFrequencies(false);
    this.SelectedFrequency = this.Frequencies[0];
    /*if (filters.Frequencies.length > 0) {
      filters.Frequencies.forEach(e => {
        this.Frequencies.push(new DDL(e));
      });
    }*/
    this.Audits = [];
    this.Audits.push(new BasicAuditReturn({ AuditID: -1, AuditName: this.customerContext.displayText("All Audits") }))
    this.SelectedAudit = this.Audits[0];
    if (filters.Audits.length > 0) {
      filters.Audits.forEach(e => {
        this.Audits.push(new BasicAuditReturn(e));
      })
      this.updateAudits();
    }
    this.Reports = [];
    if (filters.ReportList.length > 0) {
      filters.ReportList.forEach(e => {
        this.Reports.push(new ReportDetail(e));
      })
      this.SelectedReport = this.Reports[0];
    }
    const buildResult = this.buildReportingLocations(filters.Locations || []);
    this.reportingLocations = buildResult.locations;
    this.reportingLocationsByID = new Map(
      this.reportingLocations.map(location => [location.LocationID, location]));
    this.QualityManagers = this.normalisePortfolioOptions(filters.QualityManagers);
    this.BusinessDevelopmentManagers = this.normalisePortfolioOptions(filters.BusinessDevelopmentManagers);
    this.showQualityManagerFilter = environment.blueBird
      && filters.ShowQualityManagerSelector === true
      && this.actualPortfolioCount(this.QualityManagers) > 1;
    this.showBusinessDevelopmentManagerFilter = environment.blueBird
      && filters.ShowBusinessDevelopmentManagerSelector === true
      && this.actualPortfolioCount(this.BusinessDevelopmentManagers) > 1;
    this.SelectedQualityManagerID = null;
    this.SelectedBusinessDevelopmentManagerID = null;
    this.rebuildReportingLocations();
    this.updateReportControls();
  }

  get visibleQualityManagers(): DashboardPortfolioFilterOption[] {
    return this.visiblePortfolioOptions(this.QualityManagers, this.SelectedBusinessDevelopmentManagerID);
  }

  get visibleBusinessDevelopmentManagers(): DashboardPortfolioFilterOption[] {
    return this.visiblePortfolioOptions(this.BusinessDevelopmentManagers, this.SelectedQualityManagerID);
  }

  onQualityManagerChange(qualityManagerID: number | null): void {
    this.SelectedQualityManagerID = qualityManagerID;
    if (this.SelectedBusinessDevelopmentManagerID != null
        && !this.visibleBusinessDevelopmentManagers.some(option => option.ID === this.SelectedBusinessDevelopmentManagerID)) {
      this.SelectedBusinessDevelopmentManagerID = null;
    }
    this.rebuildReportingLocations();
    this.clearReportData();
  }

  onBusinessDevelopmentManagerChange(businessDevelopmentManagerID: number | null): void {
    this.SelectedBusinessDevelopmentManagerID = businessDevelopmentManagerID;
    if (this.SelectedQualityManagerID != null
        && !this.visibleQualityManagers.some(option => option.ID === this.SelectedQualityManagerID)) {
      this.SelectedQualityManagerID = null;
    }
    this.rebuildReportingLocations();
    this.clearReportData();
  }

  onReportingLocationChange(): void {
    this.clearReportData();
  }

  portfolioOptionLabel(option: DashboardPortfolioFilterOption): string {
    return option.IsActive === false ? `${option.Label} (Inactive)` : option.Label;
  }

  private normalisePortfolioOptions(options?: DashboardPortfolioFilterOption[]): DashboardPortfolioFilterOption[] {
    const unique = new Map<number, DashboardPortfolioFilterOption>();
    (options ?? [])
      .filter(option => Number.isFinite(option.ID) && !!option.Label?.trim())
      .forEach(option => unique.set(option.ID, {
        ...option,
        Label: option.Label.trim(),
        FranchiseIDs: [...new Set(option.FranchiseIDs ?? [])],
        RelatedOptionIDs: [...new Set(option.RelatedOptionIDs ?? [])]
      }));
    return Array.from(unique.values()).sort((left, right) => {
      if (!!left.IsUnassigned !== !!right.IsUnassigned) {
        return left.IsUnassigned ? 1 : -1;
      }
      return left.Label.localeCompare(right.Label, undefined, { sensitivity: 'base' });
    });
  }

  private actualPortfolioCount(options: DashboardPortfolioFilterOption[]): number {
    return options.filter(option => !option.IsUnassigned && (option.FranchiseIDs?.length ?? 0) > 0).length;
  }

  private visiblePortfolioOptions(
    options: DashboardPortfolioFilterOption[],
    relatedID: number | null
  ): DashboardPortfolioFilterOption[] {
    const selectedLocationID = this.SelectedLocation?.LocationID ?? -1;
    return options.filter(option =>
      (relatedID == null || (option.RelatedOptionIDs ?? []).includes(relatedID))
      && (selectedLocationID === -1
        || this.locationRelatesToPortfolio(selectedLocationID, option.FranchiseIDs ?? [])));
  }

  private rebuildReportingLocations(): void {
    const selectedLocationID = this.SelectedLocation?.LocationID ?? -1;
    const selectedOptions = [
      this.QualityManagers.find(option => option.ID === this.SelectedQualityManagerID),
      this.BusinessDevelopmentManagers.find(option => option.ID === this.SelectedBusinessDevelopmentManagerID)
    ].filter((option): option is DashboardPortfolioFilterOption => !!option);
    let allowedLocationIDs: Set<number> | null = null;
    selectedOptions.forEach(option => {
      const optionLocationIDs = new Set(option.FranchiseIDs ?? []);
      allowedLocationIDs = allowedLocationIDs == null
        ? optionLocationIDs
        : new Set([...allowedLocationIDs].filter(locationID => optionLocationIDs.has(locationID)));
    });
    const visibleLocations = allowedLocationIDs == null
      ? this.reportingLocations
      : this.reportingLocations.filter(location =>
          this.locationRelatesToPortfolio(location.LocationID, [...allowedLocationIDs!]));
    const allLocations = new AuditLocation({ LocationID: -1, LocationName: "All Locations" });
    const buildResult = this.buildReportingLocations(visibleLocations);
    this.Locations = [allLocations, ...buildResult.locations];
    this.LocationGroups = buildResult.groups;
    this.useLocationGroups = buildResult.useGroups;
    this.LocationGroupsWithAll = this.useLocationGroups
      ? [{ label: '', items: [allLocations] }, ...this.LocationGroups]
      : [];
    this.SelectedLocation = this.Locations.find(location => location.LocationID === selectedLocationID)
      ?? allLocations;
  }

  private locationRelatesToPortfolio(locationID: number, franchiseIDs: number[]): boolean {
    return franchiseIDs.some(franchiseID =>
      franchiseID === locationID
      || this.isReportingLocationAncestor(franchiseID, locationID)
      || this.isReportingLocationAncestor(locationID, franchiseID));
  }

  private isReportingLocationAncestor(ancestorID: number, locationID: number): boolean {
    const visited = new Set<number>();
    let currentID = locationID;
    while (currentID > 0 && visited.add(currentID)) {
      const current = this.reportingLocationsByID.get(currentID);
      if (!current || current.ParentLocationID <= 0) {
        return false;
      }
      if (current.ParentLocationID === ancestorID) {
        return true;
      }
      currentID = current.ParentLocationID;
    }
    return false;
  }

  private buildReportingLocations(locations: AuditLocation[]): {
    locations: AuditLocation[];
    groups: { label: string; items: AuditLocation[] }[];
    useGroups: boolean;
  } {
    if (!locations || locations.length === 0) {
      return { locations: [], groups: [], useGroups: false };
    }
    const normalized = locations.map(l => {
      const loc = new AuditLocation(l);
      if (!loc.LocationLevelSeq || loc.LocationLevelSeq === -1) {
        loc.LocationLevelSeq = 1;
      }
      return loc;
    });
    const nameCompare = (a: AuditLocation, b: AuditLocation) =>
      a.LocationName.localeCompare(b.LocationName, undefined, { sensitivity: 'base' });
    const levelSeqs = Array.from(new Set(normalized.map(l => l.LocationLevelSeq))).sort((a, b) => a - b);
    if (levelSeqs.length <= 1) {
      return {
        locations: normalized.sort(nameCompare),
        groups: [],
        useGroups: false
      };
    }
    const levelMap = new Map<number, number>();
    levelSeqs.forEach((seq, index) => {
      levelMap.set(seq, index + 1);
    });
    normalized.forEach(l => {
      l.LocationLevelDisplay = levelMap.get(l.LocationLevelSeq) ?? 1;
    });
    const sorted = normalized.sort((a, b) => {
      const levelDiff = (a.LocationLevelDisplay ?? 1) - (b.LocationLevelDisplay ?? 1);
      if (levelDiff !== 0) {
        return levelDiff;
      }
      return nameCompare(a, b);
    });
    const groups: { label: string; items: AuditLocation[] }[] = [];
    let currentLevel = -1;
    let currentGroup: { label: string; items: AuditLocation[] } | null = null;
    for (const loc of sorted) {
      const displayLevel = loc.LocationLevelDisplay ?? 1;
      if (displayLevel !== currentLevel) {
        currentGroup = { label: `Level ${displayLevel}`, items: [] };
        groups.push(currentGroup);
        currentLevel = displayLevel;
      }
      currentGroup?.items.push(loc);
    }
    return {
      locations: normalized,
      groups,
      useGroups: true
    };
  }
  setFrequencies(restricted: boolean) {
    this.Frequencies = [];
    this._Frequencies.forEach(e => {
      if (restricted) {
        if (e.ID != 1 && e.ID != 4) {
          this.Frequencies.push(e)
        }

      } else {
        this.Frequencies.push(e)
      }

    });
    if (this.Frequencies.findIndex(e => e.ID == this.SelectedFrequency.ID) == -1) {
      this.SelectedFrequency = this.Frequencies[0];
    }

  }
  setAllDetailSections(setting: boolean) {
    this.showAllNonComplianceDetails = setting;
    this.showAllAuditCompletionDetails = setting;
    this.showFullDetailsSection = setting;
  }
  getReport() {
    this.NoData = false;
    this.setAllDetailSections(false);
    this.clearReportData();
    this.FetchingReport = true;
    var r: ReportRequest = new ReportRequest();
    r.ReportID = this.SelectedReport.ID;
    r.StartDate = this.normalizedReportDate(this.StartDate);
    r.EndDate = this.normalizedReportDate(this.EndDate);
    r.AuditIDs = [];
    r.AuditIDs.push(this.showAuditFilter ? this.SelectedAudit.AuditID : -1);
    r.FrequencyID = this.SelectedFrequency.ID;
    r.LocationIDs = [];
    r.LocationIDs.push(this.SelectedLocation.LocationID);
    r.AuditTypeID = this.SelectedAuditType.ID;
    r.IncludeChildren = this.IncludeSubLocations;
    r.QualityManagerID = this.showQualityManagerFilter ? this.SelectedQualityManagerID : null;
    r.BusinessDevelopmentManagerID = this.showBusinessDevelopmentManagerFilter
      ? this.SelectedBusinessDevelopmentManagerID
      : null;
    this.reportingService.getReport(r).pipe(
      tap((res:ReportResult) => {
        if (res.IsError) {
          if (res.ErrorMessage == 'No data') {
            this.NoData = true;
          } else {
            this.toast.addToastr(new Toastr({ Type: 3, Message: "Unable to return to selected data, please contact support if this continues." }));
            console.error(res.ErrorCode);
          }
          this.FetchingReport = false;
        } else {
          this.storeTable(res.ReportingData);
          this.reportLoaded = true;
        }
      })
    ).subscribe();
  }
  clearReportData() {
    this.reportLoaded = false;
    this._NonComplianceRows = [];
    this.DisplayNonComplianceRows = [];
    this.CurrentNonComplianceOrder = -1;

    this._AuditCompletionRows = [];
    this.DisplayAuditCompletionRows = [];
    this.CurrentAuditCompletionOrder = -1;
    this.showOnlyAuditCompletionIssueRows = false;

    this._RiskAnalysisRows = [];
    this.monthlyAuditCompletionChartData = null;
    this.monthlyAuditCompletionChartOptions = null;
    this.monthlyAuditCompletionRows = [];
    this.monthlyActionsChartData = null;
    this.monthlyActionsChartOptions = null;
    this.monthlyActionsRows = [];

  }
  storeTable(res: ReportData) {
    switch (this.SelectedReport.ID) {

      case 1:
        res.NonComplianceRows.forEach(e => {
          this._NonComplianceRows.push(new NonComplianceRow(e));
        });
        this.resetNonComplianceData();
        break;
      case this.auditCompletionReportId:
      case this.shiftedAuditCompletionReportId:
        res.MissedAuditRows.forEach(e => {
          this._AuditCompletionRows.push(new MissedAuditRow(e));
        });
        this.resetAuditCompletionRows();
        break;
      case 3:
        res.RiskAnalysisRows.forEach(e => {
          this._RiskAnalysisRows.push(new BBCRiskAnalysisRow(e));
        })
        break;
      case 4:
        this.monthlyAuditCompletionRows = res.MonthlyAuditCompletionRows.map(row => ({
          month: row.MonthLabel,
          total: row.TotalCompleted
        }));
        this.buildMonthlyAuditCompletionChartFromRows();
        break;
      case 5:
        this.monthlyActionsRows = res.MonthlyActionsRows.map(row => ({
          month: row.MonthLabel,
          raised: row.ActionsRaised,
          completed: row.ActionsCompleted,
          completedOnTime: row.ActionsCompletedOnTime
        }));
        this.buildMonthlyActionsChartFromRows();
        break;

    }
    this.FetchingReport = false;
  }
  /*getPercentageDisplay(r:NonComplianceRow):string{
    if(r.PercentageOfAudits == -1){
      return '-'
    }else {
      return r.PercentageOfAudits.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) + "%"
    }
  }*/

  orderNCByAuditName() {
    if (this.CurrentNonComplianceOrder == 1) {
      this.DisplayNonComplianceRows.sort((a, b) => (b.Info.AuditName.localeCompare(a.Info.AuditName)))
      this.CurrentNonComplianceOrder = -1;
    } else {
      this.DisplayNonComplianceRows.sort((a, b) => (a.Info.AuditName.localeCompare(b.Info.AuditName)))
      this.CurrentNonComplianceOrder = 1;
    }

  }
  orderNCByQuestion() {
    if (this.CurrentNonComplianceOrder == 2) {
      this.DisplayNonComplianceRows.sort((a, b) => (b.Info.QuestionHeader.localeCompare(a.Info.QuestionHeader)))
      this.CurrentNonComplianceOrder = -1;
    } else {
      this.DisplayNonComplianceRows.sort((a, b) => (a.Info.QuestionHeader.localeCompare(b.Info.QuestionHeader)))
      this.CurrentNonComplianceOrder = 2;
    }
  }
  orderNCByNonCompliance() {
    if (this.CurrentNonComplianceOrder == 3) {
      this.DisplayNonComplianceRows.sort((a, b) => b.NonCompliantCounter - a.NonCompliantCounter);
      this.CurrentNonComplianceOrder = -1;
    } else {
      this.DisplayNonComplianceRows.sort((a, b) => a.NonCompliantCounter - b.NonCompliantCounter);
      this.CurrentNonComplianceOrder = 3;
    }
  }
  orderNCByCompletedAudits() {

    if (this.CurrentNonComplianceOrder == 4) {
      this.DisplayNonComplianceRows.sort((a, b) => b.CompletedQuestionsCounter - a.CompletedQuestionsCounter);
      this.CurrentNonComplianceOrder = -1;
    } else {
      this.DisplayNonComplianceRows.sort((a, b) => a.CompletedQuestionsCounter - b.CompletedQuestionsCounter);
      this.CurrentNonComplianceOrder = 4;
    }
  }
  orderNCByPercentage() {
    if (this.CurrentNonComplianceOrder == 5) {
      this.DisplayNonComplianceRows.sort((a, b) => b.CompliancePerc - a.CompliancePerc);
      this.CurrentNonComplianceOrder = -1;
    } else {
      this.DisplayNonComplianceRows.sort((a, b) => a.CompliancePerc - b.CompliancePerc);
      this.CurrentNonComplianceOrder = 5;
    }

  }
  orderAuditCompletionByAuditName() {
    if (this.CurrentAuditCompletionOrder == 1) {
      this.DisplayAuditCompletionRows.sort((a, b) => (b.Info.AuditName.localeCompare(a.Info.AuditName)))
      this.CurrentAuditCompletionOrder = -1;
    } else {
      this.DisplayAuditCompletionRows.sort((a, b) => (a.Info.AuditName.localeCompare(b.Info.AuditName)))
      this.CurrentAuditCompletionOrder = 1;
    }
  }
  orderAuditCompletionByFrequency() {
    if (this.CurrentAuditCompletionOrder == 2) {
      this.DisplayAuditCompletionRows.sort((a, b) => b.Info.FrequencyID - a.Info.FrequencyID);
      this.CurrentAuditCompletionOrder = -1;
    } else {
      this.DisplayAuditCompletionRows.sort((a, b) => b.Info.FrequencyID - a.Info.FrequencyID);
      this.CurrentAuditCompletionOrder = 2;
    }
  }
  orderAuditCompletionByCompletedAudits() {
    if (this.CurrentAuditCompletionOrder == 3) {
      this.DisplayAuditCompletionRows.sort((a, b) => b.completedAudits - a.completedAudits);
      this.CurrentAuditCompletionOrder = -1;
    } else {
      this.DisplayAuditCompletionRows.sort((a, b) => b.completedAudits - a.completedAudits);
      this.CurrentAuditCompletionOrder = 3;
    }
  }
  orderAuditCompletionByExpectedAudits() {

    if (this.CurrentAuditCompletionOrder == 4) {
      this.DisplayAuditCompletionRows.sort((a, b) => b.expectedTotalAudits - a.expectedTotalAudits);
      this.CurrentAuditCompletionOrder = -1;
    } else {
      this.DisplayAuditCompletionRows.sort((a, b) => b.expectedTotalAudits - a.expectedTotalAudits);
      this.CurrentAuditCompletionOrder = 4;
    }
  }
  orderAuditCompletionByCompletionPerc() {
    if (this.CurrentAuditCompletionOrder == 5) {
      this.DisplayAuditCompletionRows.sort((a, b) => b.percAuditsCompleted - a.percAuditsCompleted);
      this.CurrentAuditCompletionOrder = -1;
    } else {
      this.DisplayAuditCompletionRows.sort((a, b) => b.percAuditsCompleted - a.percAuditsCompleted);
      this.CurrentAuditCompletionOrder = 5;
    }
  }

  resetNonComplianceData() {
    this._NonComplianceRows.forEach(e => {
      if (this.DisplayNonComplianceRows.findIndex(f => f.Info.AuditQuestionID == e.Info.AuditQuestionID) != -1) {
        this.DisplayNonComplianceRows.find(g => g.Info.AuditQuestionID == e.Info.AuditQuestionID)?.SubNonComplianceRows.push(e);
        this.DisplayNonComplianceRows.find(g => g.Info.AuditQuestionID == e.Info.AuditQuestionID)!.CompletedQuestionsCounter += 1;
        if (!e.Compliant) {
          this.DisplayNonComplianceRows.find(g => g.Info.AuditQuestionID == e.Info.AuditQuestionID)!.NonCompliantCounter += 1;
        }
      } else {
        e.SubNonComplianceRows.push(e);
        e.CompletedQuestionsCounter = 1
        if (!e.Compliant) {
          e.NonCompliantCounter = 1;
        }
        this.DisplayNonComplianceRows.push(new NonComplianceRow(e));
      }
    });
    this.DisplayNonComplianceRows.forEach(e => {
      if (e.NonCompliantCounter == 0) {
        e.CompliancePerc = 0;
      } else {
        e.CompliancePerc = Math.round((e.NonCompliantCounter / e.CompletedQuestionsCounter) * 100);
      }
      e.SubNonComplianceRows.sort((a, b) => { if (a.Info.DateRecorded > b.Info.DateRecorded) { return 1 } return 0 })
      e.SubNonComplianceRows.forEach(f => {
        if (f.Actions.length > 0) {
          f.Actions.sort((a, b) => { if (a.Resolved > b.Resolved) { return 1 } return 0 })
        }
      })
    });
    this.DisplayNonComplianceRows.sort((a, b) => { if (a.NonCompliantCounter < b.NonCompliantCounter) { return 1 } return 0 });
  }
  resetAuditCompletionRows() {

    this._AuditCompletionRows.forEach(e => {
      var requiredAudits = e.Details.length * e.Info.FrequencyMultiplier
      var existingRow = this.DisplayAuditCompletionRows.find(f => f.Info.AuditID == e.Info.AuditID && f.Info.FrequencyID == e.Info.FrequencyID && f.Info.FrequencyMultiplier == e.Info.FrequencyMultiplier);
      if (existingRow) {
        existingRow.expectedTotalAudits += (requiredAudits);
        existingRow.completedAudits += this.completeAuditsCounter(e);
        existingRow.subRows.push(e);
      } else {
        e.subRows.push(e);
        e.expectedTotalAudits += (requiredAudits);
        e.completedAudits += this.completeAuditsCounter(e);
        this.DisplayAuditCompletionRows.push(new MissedAuditRow(e));
      }
    })
    this.DisplayAuditCompletionRows.forEach(e => {
      if (e.expectedTotalAudits > 0) {
        e.percAuditsCompleted = Math.min(Math.round((e.completedAudits / e.expectedTotalAudits) * 100), 100);
      } else {
        e.percAuditsCompleted = 0;
      }
    })
    this.DisplayAuditCompletionRows.sort((a, b) => { return a.Info.AuditName.localeCompare(b.Info.AuditName) });
    this.DisplayAuditCompletionRows.forEach(e => {
      e.subRows.sort((a, b) => a.Info.LocationName.localeCompare(b.Info.LocationName))
    })
  }
  completeAuditsCounter(auditRow: MissedAuditRow): number {
    var returnCounter = 0;
    auditRow.Details.forEach(e => {

      returnCounter += Math.min(e.TotalCompleted, auditRow.Info.FrequencyMultiplier);
    })
    return returnCounter;
  }
  auditCompletedShowOnlyIssue() {

  }
  auditCompletionDetails(rows: MissedAuditRowDetail[]): MissedAuditRowDetail[] {
    var returnRows: MissedAuditRowDetail[] = [];
    if (this.showOnlyAuditCompletionIssueRows) {
      rows.forEach(e => {
        if (!e.CompletedInPeriod) {
          returnRows.push(e)
        }

      })
      return returnRows;
    } else {
      return rows;
    }

  }
  updateAudits() {
    this.Audits.forEach(e => {
      e.Display = true;
    })
    if (this.SelectedAuditType.ID != -1) {
      this.Audits.forEach(e => {
        if (e.AuditID != -1) {
          if (e.AuditType.ID != this.SelectedAuditType.ID) {
            e.Display = false;
          }
        }

      })
    }
    if (this.SelectedFrequency.ID != -1) {
      this.Audits.forEach(e => {
        if (e.AuditID != -1) {
          if (e.AuditFrequency.ID != this.SelectedFrequency.ID) {
            e.Display = false;
          }
        }
      })
    }
    this.DisplayAudits = this.Audits.filter(e => e.Display);
    if (this.DisplayAudits.findIndex(e => { e.AuditID != this.SelectedAudit.AuditID }) == -1) {
      this.SelectedAudit = this.DisplayAudits[0];
    }
  }
  showAllNonComplianceRows() {

  }
  selectNonComplianceRow(NCR: NonComplianceRow) {
    this.selectedNonComplianceRow = NCR;
    this.showNonComplianceDetails = true;
    this.displaySelectRow();
  }
  selectActionCompletionRow(ACR: MissedAuditRow) {
    this.selectedAuditCompletionRow = ACR;
    this.showAuditCompletionDetails = true;
    this.displaySelectRow();
  }
  displaySelectRow() {
    this.showFilters = false;
    document.getElementById("scroller")!.scrollTop = 0;
  }
  noncomplianceActionDisplayName(BA: BasicAction): string {
    if (BA.Resolved) {
      return BA.ResolvedBy;
    } else {
      return BA.AssignedTo;
    }
  }
  noncomplianceActionDate(BA: BasicAction): string {
    if (BA.Resolved) {
      return this.basicDate(BA.ResolvedDate);
    } else {
      return this.basicDate(BA.ActionDeadline);
    }
  }
  noncomplianceStatus(resolved: boolean): string {
    if (resolved) {
      return "Closed";
    } else {
      return "Open";
    }
  }
  returnToSummary() {
    this.showNonComplianceDetails = false;
    this.showAuditCompletionDetails = false;
    this.showOnlyAuditCompletionIssueRows = false;
    this.setAllDetailSections(false);
    this.showFilters = true;
  }
  updateReportControls() {
    this.NoData = false;
    this.showNonComplianceDetails = false;
    this.showAuditCompletionDetails = false;
    this.setAllDetailSections(false);
    this.clearReportData();

    switch (this.SelectedReport.ID) {
      case 1:
        this.showAuditFilter = true;
        this.showLocationFilter = true;
        this.setFrequencies(false);
        this.setSingleMonthDefaults();
        break;
      case this.auditCompletionReportId:
      case this.shiftedAuditCompletionReportId:
        this.showAuditFilter = true;
        this.showLocationFilter = true;
        this.setFrequencies(true);
        this.setSingleMonthDefaults();
        break;
      case 3:
        this.showAuditFilter = false;
        this.showLocationFilter = true;
        break;
      case 4:
        this.showAuditFilter = true;
        this.showLocationFilter = true;
        this.setFrequencies(false);
        this.setSixMonthDefaults();
        break;
      case 5:
        this.showAuditFilter = false;
        this.showLocationFilter = true;
        this.setFrequencies(false);
        this.setSixMonthDefaults();
        break;
    }

  }

  /* exports */
  exportSelectedReport() {
    switch (this.SelectedReport.ID) {
      case 1:
        this.getNonComplianceExport();
        break;
      case this.auditCompletionReportId:
      case this.shiftedAuditCompletionReportId:
        this.getAuditCompletionExport();
        break;
      case 3:
        this.getRiskAnalysisReport();
        break;
      case 4:
        this.getMonthlyAuditCompletionExport();
        break;
      case 5:
        this.getMonthlyActionsExport();
        break;
      default:
        console.error('_ESR001');
        break;
    }
  }
  getRiskAnalysisReport() {
    var RD: ReportData = new ReportData();
    RD.ReportID = 3;
    RD.RiskAnalysisRows = this._RiskAnalysisRows
    if (RD.RiskAnalysisRows.length > 0) {
      this.ex.exportReport(RD).subscribe();
    } else {
      this.toast.addToastr(new Toastr({ Type: 1, Message: "No data available for export." }));
    }


  }
  getNonComplianceExport() {
    var RD: ReportData = new ReportData();
    RD.ReportID = 1;
    if (this.showAllNonComplianceDetails) {
      RD.ExportFullDetails = true;
      RD.NonComplianceRows = [];
      this._NonComplianceRows.forEach(e => {RD.NonComplianceRows.push(new NonComplianceRow(e))});
      RD.NonComplianceRows.forEach(e => {
        e.SubNonComplianceRows = [];        
      })
    } else if (this.showFilters) {
      RD.ExportSummary = true;
      RD.NonComplianceRows = this.DisplayNonComplianceRows;
    } else {
      RD.ExportSummary = false;
      RD.NonComplianceRows = this.selectedNonComplianceRow.SubNonComplianceRows;
    }
    if (RD.NonComplianceRows.length > 0) {

      this.ex.exportReport(RD).subscribe();
    } else {
      this.toast.addToastr(new Toastr({ Type: 1, Message: "No data available for export." }));
    }

  }
  getAuditCompletionExport() {
    var RD: ReportData = new ReportData();
    RD.ReportID = this.SelectedReport.ID;
    if(this.showAllAuditCompletionDetails){
      RD.ExportFullDetails = true;
      RD.MissedAuditRows = [];
      this._AuditCompletionRows.forEach(e => {RD.MissedAuditRows.push(new MissedAuditRow(e))});
      RD.MissedAuditRows.forEach(e => {
        e.subRows = [];
      })
    }else if (this.showFilters) {
      RD.ExportSummary = true;
      RD.MissedAuditRows = this.DisplayAuditCompletionRows;
    } else {
      RD.ExportSummary = false;
      RD.MissedAuditRows = this.selectedAuditCompletionRow.subRows;
      RD.MissedAuditRows.forEach(e => {
        e.Details = this.auditCompletionDetails(e.Details);
      })
    }
    if (RD.MissedAuditRows.length > 0) {
      this.ex.exportReport(RD).subscribe();
    } else {
      this.toast.addToastr(new Toastr({ Type: 1, Message: "No data available for export." }));
    }

  }

  getMonthlyAuditCompletionExport() {
    const RD: ReportData = new ReportData();
    RD.ReportID = this.auditCompletionOverviewReportId;
    RD.ExportSummary = true;
    RD.MonthlyAuditCompletionRows = this.monthlyAuditCompletionRows.map(row =>
      new MonthlyAuditCompletionRow({ MonthLabel: row.month, TotalCompleted: row.total })
    );
    if (RD.MonthlyAuditCompletionRows.length > 0) {
      this.ex.exportReport(RD).subscribe();
    } else {
      this.toast.addToastr(new Toastr({ Type: 1, Message: "No data available for export." }));
    }
  }

  getMonthlyActionsExport() {
    const RD: ReportData = new ReportData();
    RD.ReportID = this.actionsOverviewReportId;
    RD.ExportSummary = true;
    RD.MonthlyActionsRows = this.monthlyActionsRows.map(row =>
      new MonthlyActionsRow({
        MonthLabel: row.month,
        ActionsRaised: row.raised,
        ActionsCompleted: row.completed,
        ActionsCompletedOnTime: row.completedOnTime
      })
    );
    if (RD.MonthlyActionsRows.length > 0) {
      this.ex.exportReport(RD).subscribe();
    } else {
      this.toast.addToastr(new Toastr({ Type: 1, Message: "No data available for export." }));
    }
  }


  /* Filter Collapse*/
  auditFilterSwitch() {
    this.collapseAuditFilter = !this.collapseAuditFilter;
  }
  locationFilterSwitch() {
    this.collapseLocationFilter = !this.collapseLocationFilter;
  }
  optionsFilterSwitch() {
    this.collapseOptionsFilter = !this.collapseOptionsFilter;
  }


  humaniseDate(entryDate: Date): string {
    return this.util.humanDate(entryDate);
  }
  basicDate(entryDate: Date): string {
    return formatDate(entryDate, 'dd/MM/yy', 'en_GB');
  }
  auditPeriod(FrequencyID: number, start: Date, end: Date): string {
    switch (FrequencyID) {
      //daily
      case 2:
        return this.humaniseDate(start);
        break;
      //weekly
      case 3:
        return format(start, 'do') + ' - ' + format(end, 'do MMM yy');
        break;
      //monthly
      case 5:
        return format(start, 'MMM yy');
        break;
      //quarterly
      case 6:
        return format(start, 'MMM - ') + format(end, 'MMM yy');
        break;
      //semi annual
      case 7:
        return format(start, 'MMM - ') + format(end, 'MMM yy');
        break;
      //annual
      case 8:
        return format(start, 'MMM - ') + format(end, 'MMM yy');
        break;
    }
    return '';

  }
  frequencyDisplay(freqDescription: string, multi: number) {
    if (multi == 1) {
      return freqDescription;
    } else {
      return multi + 'x ' + freqDescription;
    }

  }
  removeStartDateTimeZone(event: Date) {
    const localDate = this.util.removeTimezoneFromDate(event)
    this.StartDate = localDate;
  }
  removeEndDateTimeZone(event: Date) {
    const localDate2 = this.util.removeTimezoneFromDate(event)
    this.EndDate = localDate2;
  }

  private setSingleMonthDefaults() {
    const now = new Date();
    this.StartDate = this.normalizedReportDate(new Date(now.getFullYear(), now.getMonth(), 1));
    this.EndDate = this.normalizedReportDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));
  }

  private setSixMonthDefaults() {
    const now = new Date();
    // End on the last day of the previous month, then go back 6 months from there.
    const endMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    const startMonth = new Date(endMonth.getFullYear(), endMonth.getMonth() - 5, 1);
    this.StartDate = this.normalizedReportDate(startMonth);
    this.EndDate = this.normalizedReportDate(endMonth);
  }

  private normalizedReportDate(date: Date): Date {
    return this.util.removeTimezoneFromDate(new Date(date));
  }

  showMonthlyAuditCompletionOverview(): boolean {
    return this.SelectedReport.ID === this.auditCompletionOverviewReportId && this.monthlyAuditCompletionChartData;
  }

  showMonthlyActionsOverview(): boolean {
    return this.SelectedReport.ID === this.actionsOverviewReportId && this.monthlyActionsChartData;
  }

  isAuditCompletionReport(): boolean {
    return this.SelectedReport.ID === this.auditCompletionReportId
      || this.SelectedReport.ID === this.shiftedAuditCompletionReportId;
  }

  formatOverviewCount(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '-';
    }
    return value.toLocaleString();
  }

  formatOverviewCountWhenRaised(
    value: number | null | undefined,
    raised: number | null | undefined
  ): string {
    if (raised && raised > 0) {
      const safeValue = value ?? 0;
      return safeValue.toLocaleString();
    }
    return '-';
  }

  formatOverviewPercent(numerator: number | null | undefined, denominator: number | null | undefined): string {
    if (numerator === null || numerator === undefined || denominator === null || denominator === undefined || denominator === 0) {
      return '-';
    }
    const percent = Math.round((numerator / denominator) * 100);
    return `${percent}%`;
  }

  formatOverviewPercentWhenCompleted(numerator: number | null | undefined, completed: number | null | undefined): string {
    if (!completed || completed <= 0) {
      return '-';
    }
    return this.formatOverviewPercent(numerator ?? 0, completed);
  }

  private buildMonthlyAuditCompletionChartFromRows() {
    this.monthlyAuditCompletionChartData = {
      labels: this.monthlyAuditCompletionRows.map(r => r.month),
      datasets: [
        {
          label: this.customerContext.displayText('Audits completed'),
          data: this.monthlyAuditCompletionRows.map(r => r.total),
          backgroundColor: '#1e8e5a'
        }
      ]
    };
    this.monthlyAuditCompletionChartOptions = {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: (context: any) => this.customerContext.displayText(` ${context.parsed.y} audits`)
          }
        }
      },
      scales: {
        x: {
          ticks: {
            maxRotation: 0
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            precision: 0
          }
        }
      }
    };
  }

  private buildMonthlyActionsChartFromRows() {
    this.monthlyActionsChartData = {
      labels: this.monthlyActionsRows.map(r => r.month),
      datasets: [
        {
          label: 'Actions raised',
          data: this.monthlyActionsRows.map(r => r.raised),
          borderColor: '#1e8e5a',
          backgroundColor: '#1e8e5a',
          tension: 0.3
        },
        {
          label: 'Actions completed',
          data: this.monthlyActionsRows.map(r => r.completed),
          borderColor: '#1b6dc1',
          backgroundColor: '#1b6dc1',
          tension: 0.3
        },
        {
          label: 'Completed on time',
          data: this.monthlyActionsRows.map(r => r.completedOnTime),
          borderColor: CHART_SERIES_COLOURS.completedOnTime,
          backgroundColor: CHART_SERIES_COLOURS.completedOnTime,
          tension: 0.3
        }
      ]
    };
    this.monthlyActionsChartOptions = {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom'
        },
        tooltip: {
          callbacks: {
            label: (context: any) => ` ${context.parsed.y} actions`
          }
        }
      },
      scales: {
        x: {
          ticks: {
            maxRotation: 0
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            precision: 0
          }
        }
      }
    };
  }
}

